<template>
    <section>
        <!--IT学院开始-->
        <div class="row2">
            <div class="color_3" />
            <div class="view_17">
                <span class="word_14" :lines="1">IT学院</span>
            </div>
            <div class="view_18">
                <span class="course-cate-title-active" :lines="1">C语言</span>
                <span class="course-cate-title" :lines="1">JAVA</span>
                <span class="course-cate-title" :lines="1">数据库管理</span>
                <span class="course-cate-title" :lines="1">NET</span>
                <span class="course-cate-title" :lines="1">web前端</span>
                <span class="course-cate-title" :lines="1">UI设计</span>
            </div>
            <div class="view_19">
                <span class="txt_16" :lines="1">更多</span>
                <img
                        class="icon_37"
                        src="../images/img_32389_0_471.png"
                />
            </div>
        </div>
        <img
                class="row3"
                src="../images/img_32389_0_472.png"
        />
        <div class="row4">
            <div class="block_62">
                <img
                        class="icon_38"
                        src="../images/img_32389_0_534.png"
                />
                <img
                        class="icon_39"
                        src="../images/img_32389_0_535.png"
                />
                <img
                        class="dot_7"
                        src="../images/img_32389_0_537.png"
                />
                <div class="colorDiv_4" />
                <img
                        class="dot_8"
                        src="../images/img_32389_0_523.png"
                />
                <img
                        class="img_14"
                        src="../images/img_32389_0_524.png"
                />
                <img
                        class="shopLogo"
                        src="../images/img_32389_0_473.png"
                />
                <div class="view_20">
                    <img
                            class="logo_11"
                            src="../images/img_32389_0_474.png"
                    />
                    <div class="block_55">
                        <img
                                class="icon_40"
                                src="../images/img_32389_0_542.png"
                        />
                        <img
                                class="dot_9"
                                src="../images/img_32389_0_543.png"
                        />
                    </div>
                    <img
                            class="icon_41"
                            src="../images/img_32389_0_544.png"
                    />
                    <img
                            class="icon_42"
                            src="../images/img_32389_0_545.png"
                    />
                    <div class="block_56">
                        <img
                                class="icon_43"
                                src="../images/img_32389_0_546.png"
                        />
                        <img
                                class="dot_10"
                                src="../images/img_32389_0_547.png"
                        />
                    </div>
                    <img
                            class="icon_44"
                            src="../images/img_32389_0_548.png"
                    />
                    <img
                            class="icon_45"
                            src="../images/img_32389_0_550.png"
                    />
                    <img
                            class="icon_46"
                            src="../images/img_32389_0_549.png"
                    />
                    <div class="block_57">
                        <img
                                class="icon_47"
                                src="../images/img_32389_0_551.png"
                        />
                        <img
                                class="icon_48"
                                src="../images/img_32389_0_552.png"
                        />
                        <img
                                class="dot_11"
                                src="../images/img_32389_0_553.png"
                        />
                    </div>
                    <div class="block_58">
                        <img
                                class="icon_49"
                                src="../images/img_32389_0_554.png"
                        />
                        <img
                                class="dot_12"
                                src="../images/img_32389_0_555.png"
                        />
                    </div>
                    <img
                            class="icon_50"
                            src="../images/img_32389_0_556.png"
                    />
                    <img
                            class="icon_51"
                            src="../images/img_32389_0_557.png"
                    />
                </div>
                <img
                        class="priceIcon"
                        src="../images/img_32389_0_476.png"
                />
                <span class="academy" :lines="1">IT ACADEMY</span>
                <span class="academyNext" :lines="5"
                >IT学院联合国内一线行业大咖共同打造的课程体系，全面覆盖“前端”开发、H5开发、Java架构师等热门职位</span
                >
                <div class="color_4" />
                <img
                        class="dot_13"
                        src="../images/img_32389_0_506.png"
                />
                <img
                        class="img_15"
                        src="../images/img_32389_0_507.png"
                />
                <div class="view_21">
                    <img
                            class="icon_52"
                            src="../images/img_32389_0_509.png"
                    />
                    <img
                            class="icon_53"
                            src="../images/img_32389_0_525.png"
                    />
                    <div class="block_59">
                        <img
                                class="image_5"
                                src="../images/img_32389_0_530.png"
                        />
                        <img
                                class="dot_14"
                                src="../images/img_32389_0_532.png"
                        />
                    </div>
                </div>
                <img
                        class="logo_12"
                        src="../images/img_32389_0_477.png"
                />
                <img
                        class="logo_13"
                        src="../images/img_32389_0_475.png"
                />
                <img
                        class="pic_8"
                        src="../images/img_32389_0_478.png"
                />
                <img
                        class="img_16"
                        src="../images/img_32389_0_508.png"
                />
                <img
                        class="image_6"
                        src="../images/img_32389_0_512.png"
                />
                <div class="block_60">
                    <img
                            class="picture_9"
                            src="../images/img_32389_0_513.png"
                    />
                    <img
                            class="dot_15"
                            src="../images/img_32389_0_516.png"
                    />
                </div>
                <img
                        class="img_17"
                        src="../images/img_32389_0_479.png"
                />
                <img
                        class="logo_14"
                        src="../images/img_32389_0_480.png"
                />
                <img
                        class="logo_15"
                        src="../images/img_32389_0_481.png"
                />
                <img
                        class="icon_54"
                        src="../images/img_32389_0_514.png"
                />
                <img
                        class="dot_16"
                        src="../images/img_32389_0_517.png"
                />
                <img
                        class="smallItem"
                        src="../images/img_32389_0_482.png"
                />
                <div class="view_22">
                    <img
                            class="smallImg"
                            src="../images/img_32389_0_483.png"
                    />
                    <img
                            class="icon_55"
                            src="../images/img_32389_0_518.png"
                    />
                    <img
                            class="icon_56"
                            src="../images/img_32389_0_519.png"
                    />
                    <img
                            class="pic_9"
                            src="../images/img_32389_0_520.png"
                    />
                    <img
                            class="icon_57"
                            src="../images/img_32389_0_501.png"
                    />
                    <img
                            class="icon_58"
                            src="../images/img_32389_0_502.png"
                    />
                    <img
                            class="picture_10"
                            src="../images/img_32389_0_503.png"
                    />
                    <img
                            class="icon_59"
                            src="../images/img_32389_0_504.png"
                    />
                    <img
                            class="dot_17"
                            src="../images/img_32389_0_511.png"
                    />
                    <img
                            class="dot_18"
                            src="../images/img_32389_0_510.png"
                    />
                    <img
                            class="icon_60"
                            src="../images/img_32389_0_505.png"
                    />
                    <img
                            class="icon_61"
                            src="../images/img_32389_0_521.png"
                    />
                    <img
                            class="dot_19"
                            src="../images/img_32389_0_528.png"
                    />
                    <img
                            class="dot_20"
                            src="../images/img_32389_0_527.png"
                    />
                    <img
                            class="icon_62"
                            src="../images/img_32389_0_522.png"
                    />
                </div>
                <img
                        class="icon_63"
                        src="../images/img_32389_0_526.png"
                />
                <img
                        class="image_7"
                        src="../images/img_32389_0_529.png"
                />
                <img
                        class="icon_64"
                        src="../images/img_32389_0_531.png"
                />
                <img
                        class="dot_21"
                        src="../images/img_32389_0_533.png"
                />
                <img
                        class="dot_22"
                        src="../images/img_32389_0_515.png"
                />
                <img
                        class="icon_65"
                        src="../images/img_32389_0_487.png"
                />
                <img
                        class="icon_66"
                        src="../images/img_32389_0_486.png"
                />
                <img
                        class="icon_67"
                        src="../images/img_32389_0_485.png"
                />
                <img
                        class="icon_68"
                        src="../images/img_32389_0_484.png"
                />
                <img
                        class="image_8"
                        src="../images/img_32389_0_489.png"
                />
                <img
                        class="picture_11"
                        src="../images/img_32389_0_488.png"
                />
                <img
                        class="icon_69"
                        src="../images/img_32389_0_490.png"
                />
                <div class="block_61">
                    <img
                            class="icon_70"
                            src="../images/img_32389_0_491.png"
                    />
                    <img
                            class="icon_71"
                            src="../images/img_32389_0_497.png"
                    />
                    <img
                            class="icon_72"
                            src="../images/img_32389_0_496.png"
                    />
                    <img
                            class="icon_73"
                            src="../images/img_32389_0_495.png"
                    />
                    <img
                            class="icon_74"
                            src="../images/img_32389_0_494.png"
                    />
                    <img
                            class="icon_75"
                            src="../images/img_32389_0_493.png"
                    />
                    <img
                            class="icon_76"
                            src="../images/img_32389_0_492.png"
                    />
                </div>
                <img
                        class="icon_77"
                        src="../images/img_32389_0_500.png"
                />
                <img
                        class="icon_78"
                        src="../images/img_32389_0_499.png"
                />
                <img
                        class="icon_79"
                        src="../images/img_32389_0_498.png"
                />
                <img
                        class="icon_80"
                        src="../images/img_32389_0_536.png"
                />
                <img
                        class="icon_81"
                        src="../images/img_32389_0_538.png"
                />
                <img
                        class="icon_82"
                        src="../images/img_32389_0_539.png"
                />
                <img
                        class="dot_23"
                        src="../images/img_32389_0_541.png"
                />
                <img
                        class="icon_83"
                        src="../images/img_32389_0_540.png"
                />
            </div>
            <div class="block_63">
                <el-card shadow="hover" :body-style="{ padding: '5px'}">
                    <img
                            class="entryPic_8"
                            src="../images/img_32389_0_455.png"
                    />
                    <div class="block_67">
                        <span class="info_28" :lines="1">深度学习与子人处深</span>
                        <span class="text_17" :lines="1">…</span>
                    </div>
                    <div class="moneyWrap_5">
                        <div class="block_69">
                            <div class="block_68">
                                <img
                                        class="icon_88"
                                        src="../images/img_32389_0_457.png"
                                />
                                <img
                                        class="img_18"
                                        src="../images/img_32389_0_458.png"
                                />
                                <img
                                        class="icon_89"
                                        src="../images/img_32389_0_459.png"
                                />
                            </div>
                            <span class="num_11" :lines="1">2389</span>
                        </div>
                        <span class="money_5" :lines="1">¥1200.00</span>
                    </div>
                </el-card>
                <el-card shadow="hover" :body-style="{ padding: '5px'}">
                    <img
                            class="entryPic_8"
                            src="../images/img_32389_0_455.png"
                    />
                    <div class="block_67">
                        <span class="info_28" :lines="1">深度学习与子人处深</span>
                        <span class="text_17" :lines="1">…</span>
                    </div>
                    <div class="moneyWrap_5">
                        <div class="block_69">
                            <div class="block_68">
                                <img
                                        class="icon_88"
                                        src="../images/img_32389_0_457.png"
                                />
                                <img
                                        class="img_18"
                                        src="../images/img_32389_0_458.png"
                                />
                                <img
                                        class="icon_89"
                                        src="../images/img_32389_0_459.png"
                                />
                            </div>
                            <span class="num_11" :lines="1">2389</span>
                        </div>
                        <span class="money_5" :lines="1">¥1200.00</span>
                    </div>
                </el-card>
                <el-card shadow="hover" :body-style="{ padding: '5px'}">
                    <img
                            class="entryPic_8"
                            src="../images/img_32389_0_455.png"
                    />
                    <div class="block_67">
                        <span class="info_28" :lines="1">深度学习与子人处深</span>
                        <span class="text_17" :lines="1">…</span>
                    </div>
                    <div class="moneyWrap_5">
                        <div class="block_69">
                            <div class="block_68">
                                <img
                                        class="icon_88"
                                        src="../images/img_32389_0_457.png"
                                />
                                <img
                                        class="img_18"
                                        src="../images/img_32389_0_458.png"
                                />
                                <img
                                        class="icon_89"
                                        src="../images/img_32389_0_459.png"
                                />
                            </div>
                            <span class="num_11" :lines="1">2389</span>
                        </div>
                        <span class="money_5" :lines="1">¥1200.00</span>
                    </div>
                </el-card>
                <el-card shadow="hover" :body-style="{ padding: '5px'}">
                    <img
                            class="entryPic_8"
                            src="../images/img_32389_0_455.png"
                    />
                    <div class="block_67">
                        <span class="info_28" :lines="1">深度学习与子人处深</span>
                        <span class="text_17" :lines="1">…</span>
                    </div>
                    <div class="moneyWrap_5">
                        <div class="block_69">
                            <div class="block_68">
                                <img
                                        class="icon_88"
                                        src="../images/img_32389_0_457.png"
                                />
                                <img
                                        class="img_18"
                                        src="../images/img_32389_0_458.png"
                                />
                                <img
                                        class="icon_89"
                                        src="../images/img_32389_0_459.png"
                                />
                            </div>
                            <span class="num_11" :lines="1">2389</span>
                        </div>
                        <span class="money_5" :lines="1">¥1200.00</span>
                    </div>
                </el-card>
                <el-card shadow="hover" :body-style="{ padding: '5px'}">
                    <img
                            class="entryPic_8"
                            src="../images/img_32389_0_455.png"
                    />
                    <div class="block_67">
                        <span class="info_28" :lines="1">深度学习与子人处深</span>
                        <span class="text_17" :lines="1">…</span>
                    </div>
                    <div class="moneyWrap_5">
                        <div class="block_69">
                            <div class="block_68">
                                <img
                                        class="icon_88"
                                        src="../images/img_32389_0_457.png"
                                />
                                <img
                                        class="img_18"
                                        src="../images/img_32389_0_458.png"
                                />
                                <img
                                        class="icon_89"
                                        src="../images/img_32389_0_459.png"
                                />
                            </div>
                            <span class="num_11" :lines="1">2389</span>
                        </div>
                        <span class="money_5" :lines="1">¥1200.00</span>
                    </div>
                </el-card>
                <el-card shadow="hover" :body-style="{ padding: '5px'}">
                    <img
                            class="entryPic_8"
                            src="../images/img_32389_0_455.png"
                    />
                    <div class="block_67">
                        <span class="info_28" :lines="1">深度学习与子人处深</span>
                        <span class="text_17" :lines="1">…</span>
                    </div>
                    <div class="moneyWrap_5">
                        <div class="block_69">
                            <div class="block_68">
                                <img
                                        class="icon_88"
                                        src="../images/img_32389_0_457.png"
                                />
                                <img
                                        class="img_18"
                                        src="../images/img_32389_0_458.png"
                                />
                                <img
                                        class="icon_89"
                                        src="../images/img_32389_0_459.png"
                                />
                            </div>
                            <span class="num_11" :lines="1">2389</span>
                        </div>
                        <span class="money_5" :lines="1">¥1200.00</span>
                    </div>
                </el-card>
            </div>
        </div>
        <!--大数据开始-->
        <div class="row7">
            <div class="color_6" />
            <div class="view_43">
                <span class="title_2" :lines="1">大数据学院</span>
                <span class="word_20" :lines="1">默认分类</span>
            </div>
            <div class="block_110">
                <span class="text_33" :lines="1">更多</span>
                <img
                        class="icon_166"
                        src="../images/img_32389_0_250.png"
                />
            </div>
        </div>
        <img
                class="row3"
                src="../images/img_32389_0_472.png"
        />
        <div class="row4">
            <div class="block_62">
                <img
                        class="icon_38"
                        src="../images/img_32389_0_534.png"
                />
                <img
                        class="icon_39"
                        src="../images/img_32389_0_535.png"
                />
                <img
                        class="dot_7"
                        src="../images/img_32389_0_537.png"
                />
                <div class="colorDiv_4" />
                <img
                        class="dot_8"
                        src="../images/img_32389_0_523.png"
                />
                <img
                        class="img_14"
                        src="../images/img_32389_0_524.png"
                />
                <img
                        class="shopLogo"
                        src="../images/img_32389_0_473.png"
                />
                <div class="view_20">
                    <img
                            class="logo_11"
                            src="../images/img_32389_0_474.png"
                    />
                    <div class="block_55">
                        <img
                                class="icon_40"
                                src="../images/img_32389_0_542.png"
                        />
                        <img
                                class="dot_9"
                                src="../images/img_32389_0_543.png"
                        />
                    </div>
                    <img
                            class="icon_41"
                            src="../images/img_32389_0_544.png"
                    />
                    <img
                            class="icon_42"
                            src="../images/img_32389_0_545.png"
                    />
                    <div class="block_56">
                        <img
                                class="icon_43"
                                src="../images/img_32389_0_546.png"
                        />
                        <img
                                class="dot_10"
                                src="../images/img_32389_0_547.png"
                        />
                    </div>
                    <img
                            class="icon_44"
                            src="../images/img_32389_0_548.png"
                    />
                    <img
                            class="icon_45"
                            src="../images/img_32389_0_550.png"
                    />
                    <img
                            class="icon_46"
                            src="../images/img_32389_0_549.png"
                    />
                    <div class="block_57">
                        <img
                                class="icon_47"
                                src="../images/img_32389_0_551.png"
                        />
                        <img
                                class="icon_48"
                                src="../images/img_32389_0_552.png"
                        />
                        <img
                                class="dot_11"
                                src="../images/img_32389_0_553.png"
                        />
                    </div>
                    <div class="block_58">
                        <img
                                class="icon_49"
                                src="../images/img_32389_0_554.png"
                        />
                        <img
                                class="dot_12"
                                src="../images/img_32389_0_555.png"
                        />
                    </div>
                    <img
                            class="icon_50"
                            src="../images/img_32389_0_556.png"
                    />
                    <img
                            class="icon_51"
                            src="../images/img_32389_0_557.png"
                    />
                </div>
                <img
                        class="priceIcon"
                        src="../images/img_32389_0_476.png"
                />
                <span class="academy" :lines="1">IT ACADEMY</span>
                <span class="academyNext" :lines="5"
                >IT学院联合国内一线行业大咖共同打造的课程体系，全面覆盖“前端”开发、H5开发、Java架构师等热门职位</span
                >
                <div class="color_4" />
                <img
                        class="dot_13"
                        src="../images/img_32389_0_506.png"
                />
                <img
                        class="img_15"
                        src="../images/img_32389_0_507.png"
                />
                <div class="view_21">
                    <img
                            class="icon_52"
                            src="../images/img_32389_0_509.png"
                    />
                    <img
                            class="icon_53"
                            src="../images/img_32389_0_525.png"
                    />
                    <div class="block_59">
                        <img
                                class="image_5"
                                src="../images/img_32389_0_530.png"
                        />
                        <img
                                class="dot_14"
                                src="../images/img_32389_0_532.png"
                        />
                    </div>
                </div>
                <img
                        class="logo_12"
                        src="../images/img_32389_0_477.png"
                />
                <img
                        class="logo_13"
                        src="../images/img_32389_0_475.png"
                />
                <img
                        class="pic_8"
                        src="../images/img_32389_0_478.png"
                />
                <img
                        class="img_16"
                        src="../images/img_32389_0_508.png"
                />
                <img
                        class="image_6"
                        src="../images/img_32389_0_512.png"
                />
                <div class="block_60">
                    <img
                            class="picture_9"
                            src="../images/img_32389_0_513.png"
                    />
                    <img
                            class="dot_15"
                            src="../images/img_32389_0_516.png"
                    />
                </div>
                <img
                        class="img_17"
                        src="../images/img_32389_0_479.png"
                />
                <img
                        class="logo_14"
                        src="../images/img_32389_0_480.png"
                />
                <img
                        class="logo_15"
                        src="../images/img_32389_0_481.png"
                />
                <img
                        class="icon_54"
                        src="../images/img_32389_0_514.png"
                />
                <img
                        class="dot_16"
                        src="../images/img_32389_0_517.png"
                />
                <img
                        class="smallItem"
                        src="../images/img_32389_0_482.png"
                />
                <div class="view_22">
                    <img
                            class="smallImg"
                            src="../images/img_32389_0_483.png"
                    />
                    <img
                            class="icon_55"
                            src="../images/img_32389_0_518.png"
                    />
                    <img
                            class="icon_56"
                            src="../images/img_32389_0_519.png"
                    />
                    <img
                            class="pic_9"
                            src="../images/img_32389_0_520.png"
                    />
                    <img
                            class="icon_57"
                            src="../images/img_32389_0_501.png"
                    />
                    <img
                            class="icon_58"
                            src="../images/img_32389_0_502.png"
                    />
                    <img
                            class="picture_10"
                            src="../images/img_32389_0_503.png"
                    />
                    <img
                            class="icon_59"
                            src="../images/img_32389_0_504.png"
                    />
                    <img
                            class="dot_17"
                            src="../images/img_32389_0_511.png"
                    />
                    <img
                            class="dot_18"
                            src="../images/img_32389_0_510.png"
                    />
                    <img
                            class="icon_60"
                            src="../images/img_32389_0_505.png"
                    />
                    <img
                            class="icon_61"
                            src="../images/img_32389_0_521.png"
                    />
                    <img
                            class="dot_19"
                            src="../images/img_32389_0_528.png"
                    />
                    <img
                            class="dot_20"
                            src="../images/img_32389_0_527.png"
                    />
                    <img
                            class="icon_62"
                            src="../images/img_32389_0_522.png"
                    />
                </div>
                <img
                        class="icon_63"
                        src="../images/img_32389_0_526.png"
                />
                <img
                        class="image_7"
                        src="../images/img_32389_0_529.png"
                />
                <img
                        class="icon_64"
                        src="../images/img_32389_0_531.png"
                />
                <img
                        class="dot_21"
                        src="../images/img_32389_0_533.png"
                />
                <img
                        class="dot_22"
                        src="../images/img_32389_0_515.png"
                />
                <img
                        class="icon_65"
                        src="../images/img_32389_0_487.png"
                />
                <img
                        class="icon_66"
                        src="../images/img_32389_0_486.png"
                />
                <img
                        class="icon_67"
                        src="../images/img_32389_0_485.png"
                />
                <img
                        class="icon_68"
                        src="../images/img_32389_0_484.png"
                />
                <img
                        class="image_8"
                        src="../images/img_32389_0_489.png"
                />
                <img
                        class="picture_11"
                        src="../images/img_32389_0_488.png"
                />
                <img
                        class="icon_69"
                        src="../images/img_32389_0_490.png"
                />
                <div class="block_61">
                    <img
                            class="icon_70"
                            src="../images/img_32389_0_491.png"
                    />
                    <img
                            class="icon_71"
                            src="../images/img_32389_0_497.png"
                    />
                    <img
                            class="icon_72"
                            src="../images/img_32389_0_496.png"
                    />
                    <img
                            class="icon_73"
                            src="../images/img_32389_0_495.png"
                    />
                    <img
                            class="icon_74"
                            src="../images/img_32389_0_494.png"
                    />
                    <img
                            class="icon_75"
                            src="../images/img_32389_0_493.png"
                    />
                    <img
                            class="icon_76"
                            src="../images/img_32389_0_492.png"
                    />
                </div>
                <img
                        class="icon_77"
                        src="../images/img_32389_0_500.png"
                />
                <img
                        class="icon_78"
                        src="../images/img_32389_0_499.png"
                />
                <img
                        class="icon_79"
                        src="../images/img_32389_0_498.png"
                />
                <img
                        class="icon_80"
                        src="../images/img_32389_0_536.png"
                />
                <img
                        class="icon_81"
                        src="../images/img_32389_0_538.png"
                />
                <img
                        class="icon_82"
                        src="../images/img_32389_0_539.png"
                />
                <img
                        class="dot_23"
                        src="../images/img_32389_0_541.png"
                />
                <img
                        class="icon_83"
                        src="../images/img_32389_0_540.png"
                />
            </div>
            <div class="view_24">
                <div class="view_23">
                    <img
                            class="entryPic_6"
                            src="../images/img_32389_0_463.png"
                    />
                    <div class="block_63">
                        <span class="info_26" :lines="1">深度学习与子人处深</span>
                        <span class="txt_17" :lines="1">…</span>
                    </div>
                    <div class="priceWrap_4">
                        <div class="block_64">
                            <div class="container">
                                <img
                                        class="icon_84"
                                        src="../images/img_32389_0_465.png"
                                />
                                <img
                                        class="pic_10"
                                        src="../images/img_32389_0_466.png"
                                />
                                <img
                                        class="icon_85"
                                        src="../images/img_32389_0_467.png"
                                />
                            </div>
                            <span class="num_9" :lines="1">2389</span>
                        </div>
                        <span class="price_4" :lines="1">¥1200.00</span>
                    </div>
                </div>
                <img
                        class="entryPic_7"
                        src="../images/img_32389_0_464.png"
                />
                <div class="block_65">
                    <span class="info_27" :lines="1">深度学习与子人处深</span>
                    <span class="text_16" :lines="1">…</span>
                </div>
                <div class="priceWrap_5">
                    <div class="block_66">
                        <div class="group_17">
                            <img
                                    class="icon_86"
                                    src="../images/img_32389_0_468.png"
                            />
                            <img
                                    class="image_9"
                                    src="../images/img_32389_0_469.png"
                            />
                            <img
                                    class="icon_87"
                                    src="../images/img_32389_0_470.png"
                            />
                        </div>
                        <span class="num_10" :lines="1">2389</span>
                    </div>
                    <span class="price_5" :lines="1">¥1200.00</span>
                </div>
            </div>
            <div class="block_72">
                <img
                        class="entryPic_8"
                        src="../images/img_32389_0_455.png"
                />
                <div class="block_67">
                    <span class="info_28" :lines="1">深度学习与子人处深</span>
                    <span class="text_17" :lines="1">…</span>
                </div>
                <div class="moneyWrap_5">
                    <div class="block_69">
                        <div class="block_68">
                            <img
                                    class="icon_88"
                                    src="../images/img_32389_0_457.png"
                            />
                            <img
                                    class="img_18"
                                    src="../images/img_32389_0_458.png"
                            />
                            <img
                                    class="icon_89"
                                    src="../images/img_32389_0_459.png"
                            />
                        </div>
                        <span class="num_11" :lines="1">2389</span>
                    </div>
                    <span class="money_5" :lines="1">¥1200.00</span>
                </div>
                <img
                        class="entryPic_9"
                        src="../images/img_32389_0_456.png"
                />
                <div class="block_70">
                    <span class="info_29" :lines="1">深度学习与子人处深</span>
                    <span class="text_18" :lines="1">…</span>
                </div>
                <div class="priceWrap_6">
                    <div class="block_71">
                        <div class="group_18">
                            <img
                                    class="icon_90"
                                    src="../images/img_32389_0_460.png"
                            />
                            <img
                                    class="pic_11"
                                    src="../images/img_32389_0_461.png"
                            />
                            <img
                                    class="icon_91"
                                    src="../images/img_32389_0_462.png"
                            />
                        </div>
                        <span class="num_12" :lines="1">2389</span>
                    </div>
                    <span class="price_6" :lines="1">¥1200.00</span>
                </div>
            </div>
            <div class="view_25">
                <img
                        class="entryPic_10"
                        src="../images/img_32389_0_447.png"
                />
                <div class="block_73">
                    <span class="info_30" :lines="1">深度学习与子人处深</span>
                    <span class="text_19" :lines="1">…</span>
                </div>
                <div class="moneyWrap_6">
                    <div class="block_75">
                        <div class="block_74">
                            <img
                                    class="icon_92"
                                    src="../images/img_32389_0_449.png"
                            />
                            <img
                                    class="picture_12"
                                    src="../images/img_32389_0_450.png"
                            />
                            <img
                                    class="icon_93"
                                    src="../images/img_32389_0_451.png"
                            />
                        </div>
                        <span class="num_13" :lines="1">2389</span>
                    </div>
                    <span class="money_6" :lines="1">¥1200.00</span>
                </div>
                <img
                        class="entryPic_11"
                        src="../images/img_32389_0_448.png"
                />
                <div class="block_76">
                    <span class="info_31" :lines="1">深度学习与子人处深</span>
                    <span class="text_20" :lines="1">…</span>
                </div>
                <div class="priceWrap_7">
                    <div class="block_77">
                        <div class="group_19">
                            <img
                                    class="icon_94"
                                    src="../images/img_32389_0_452.png"
                            />
                            <img
                                    class="image_10"
                                    src="../images/img_32389_0_453.png"
                            />
                            <img
                                    class="icon_95"
                                    src="../images/img_32389_0_454.png"
                            />
                        </div>
                        <span class="num_14" :lines="1">2389</span>
                    </div>
                    <span class="price_7" :lines="1">¥1200.00</span>
                </div>
            </div>
            <div class="block_83">
                <img
                        class="entryPic_12"
                        src="../images/img_32389_0_439.png"
                />
                <div class="block_78">
                    <span class="info_32" :lines="1">深度学习与子人处深</span>
                    <span class="text_21" :lines="1">…</span>
                </div>
                <div class="moneyWrap_7">
                    <div class="block_80">
                        <div class="block_79">
                            <img
                                    class="icon_96"
                                    src="../images/img_32389_0_441.png"
                            />
                            <img
                                    class="img_19"
                                    src="../images/img_32389_0_442.png"
                            />
                            <img
                                    class="icon_97"
                                    src="../images/img_32389_0_443.png"
                            />
                        </div>
                        <span class="num_15" :lines="1">2389</span>
                    </div>
                    <span class="money_7" :lines="1">¥1200.00</span>
                </div>
                <img
                        class="entryPic_13"
                        src="../images/img_32389_0_440.png"
                />
                <div class="block_81">
                    <span class="info_33" :lines="1">深度学习与子人处深</span>
                    <span class="text_22" :lines="1">…</span>
                </div>
                <div class="priceWrap_8">
                    <div class="block_82">
                        <div class="group_20">
                            <img
                                    class="icon_98"
                                    src="../images/img_32389_0_444.png"
                            />
                            <img
                                    class="pic_12"
                                    src="../images/img_32389_0_445.png"
                            />
                            <img
                                    class="icon_99"
                                    src="../images/img_32389_0_446.png"
                            />
                        </div>
                        <span class="num_16" :lines="1">2389</span>
                    </div>
                    <span class="price_8" :lines="1">¥1200.00</span>
                </div>
            </div>
        </div>
        <div class="row7">
            <div class="color_6" />
            <div class="view_43">
                <span class="title_2" :lines="1">技能扩展中心</span>
                <span class="word_20" :lines="1">默认分类</span>
            </div>
            <div class="block_110">
                <span class="text_33" :lines="1">更多</span>
                <img
                        class="icon_166"
                        src="../images/img_32389_0_250.png"
                />
            </div>
        </div>
        <img
                class="row8"
                src="../images/img_32389_0_251.png"
        />
        <div class="row9">
            <div class="col1_2">
                <img
                        class="entryPic_22"
                        src="../images/img_32389_0_234.png"
                />
                <div class="summaryWrap_3">
            <span class="summary_4" :lines="2"
            >深度学习与子人语深度深度学习与子人语深度深度学习与子人语</span
            >
                    <span class="word_21" :lines="1">…</span>
                </div>
                <div class="priceWrap_12">
                    <div class="block_111">
                        <div class="group_24">
                            <img
                                    class="icon_167"
                                    src="../images/img_32389_0_235.png"
                            />
                            <img
                                    class="pic_17"
                                    src="../images/img_32389_0_236.png"
                            />
                            <img
                                    class="icon_168"
                                    src="../images/img_32389_0_237.png"
                            />
                        </div>
                        <span class="num_24" :lines="1">2389</span>
                    </div>
                    <span class="price_13" :lines="1">¥1200.00</span>
                </div>
            </div>
            <div class="col2_2">
                <img
                        class="entryPic_23"
                        src="../images/img_32389_0_238.png"
                />
                <div class="summaryWrap_4">
            <span class="summary_5" :lines="2"
            >深度学习与子人语深度深度学习与子人语深度深度学习与子人语</span
            >
                    <span class="word_22" :lines="1">…</span>
                </div>
                <div class="moneyWrap_12">
                    <div class="block_113">
                        <div class="block_112">
                            <img
                                    class="icon_169"
                                    src="../images/img_32389_0_239.png"
                            />
                            <img
                                    class="picture_20"
                                    src="../images/img_32389_0_240.png"
                            />
                            <img
                                    class="icon_170"
                                    src="../images/img_32389_0_241.png"
                            />
                        </div>
                        <span class="num_25" :lines="1">2389</span>
                    </div>
                    <span class="money_12" :lines="1">¥1200.00</span>
                </div>
            </div>
            <div class="col3_2">
                <img
                        class="entryPic_24"
                        src="../images/img_32389_0_242.png"
                />
                <div class="summaryWrap_5">
            <span class="summary_6" :lines="2"
            >深度学习与子人语深度深度学习与子人语深度深度学习与子人语</span
            >
                    <span class="word_23" :lines="1">…</span>
                </div>
                <div class="priceWrap_13">
                    <div class="block_114">
                        <div class="group_25">
                            <img
                                    class="icon_171"
                                    src="../images/img_32389_0_243.png"
                            />
                            <img
                                    class="image_18"
                                    src="../images/img_32389_0_244.png"
                            />
                            <img
                                    class="icon_172"
                                    src="../images/img_32389_0_245.png"
                            />
                        </div>
                        <span class="num_26" :lines="1">2389</span>
                    </div>
                    <span class="price_14" :lines="1">¥1200.00</span>
                </div>
            </div>
            <div class="col4_2">
                <img
                        class="entryPic_25"
                        src="../images/img_32389_0_246.png"
                />
                <div class="summaryWrap_6">
            <span class="summary_7" :lines="2"
            >深度学习与子人语深度深度学习与子人语深度深度学习与子人语</span
            >
                    <span class="word_24" :lines="1">…</span>
                </div>
                <div class="moneyWrap_13">
                    <div class="block_116">
                        <div class="block_115">
                            <img
                                    class="icon_173"
                                    src="../images/img_32389_0_247.png"
                            />
                            <img
                                    class="img_24"
                                    src="../images/img_32389_0_248.png"
                            />
                            <img
                                    class="icon_174"
                                    src="../images/img_32389_0_249.png"
                            />
                        </div>
                        <span class="num_27" :lines="1">2389</span>
                    </div>
                    <span class="money_13" :lines="1">¥1200.00</span>
                </div>
            </div>
        </div>
        <div class="row10">
            <div class="colorDiv_7" />
            <div class="block_117">
                <span class="title_3" :lines="1">职场发展中心</span>
                <span class="word_25" :lines="1">默认分类</span>
            </div>
            <div class="view_44">
                <span class="text_34" :lines="1">更多</span>
                <img
                        class="icon_175"
                        src="../images/img_32389_0_147.png"
                />
            </div>
        </div>
        <img
                class="row11"
                src="../images/img_32389_0_233.png"
        />
        <div class="row12">
            <div class="block_125">
                <img
                        class="icon_176"
                        src="../images/img_32389_0_209.png"
                />
                <img
                        class="icon_177"
                        src="../images/img_32389_0_210.png"
                />
                <img
                        class="dot_41"
                        src="../images/img_32389_0_212.png"
                />
                <div class="colorDiv_8" />
                <img
                        class="dot_42"
                        src="../images/img_32389_0_198.png"
                />
                <img
                        class="picture_21"
                        src="../images/img_32389_0_199.png"
                />
                <img
                        class="shopLogo_3"
                        src="../images/img_32389_0_148.png"
                />
                <div class="view_45">
                    <img
                            class="logo_21"
                            src="../images/img_32389_0_149.png"
                    />
                    <div class="block_118">
                        <img
                                class="icon_178"
                                src="../images/img_32389_0_217.png"
                        />
                        <img
                                class="dot_43"
                                src="../images/img_32389_0_218.png"
                        />
                    </div>
                    <img
                            class="icon_179"
                            src="../images/img_32389_0_219.png"
                    />
                    <img
                            class="icon_180"
                            src="../images/img_32389_0_220.png"
                    />
                    <div class="block_119">
                        <img
                                class="icon_181"
                                src="../images/img_32389_0_221.png"
                        />
                        <img
                                class="dot_44"
                                src="../images/img_32389_0_222.png"
                        />
                    </div>
                    <img
                            class="icon_182"
                            src="../images/img_32389_0_223.png"
                    />
                    <img
                            class="icon_183"
                            src="../images/img_32389_0_225.png"
                    />
                    <img
                            class="icon_184"
                            src="../images/img_32389_0_224.png"
                    />
                    <div class="block_120">
                        <img
                                class="icon_185"
                                src="../images/img_32389_0_226.png"
                        />
                        <img
                                class="icon_186"
                                src="../images/img_32389_0_227.png"
                        />
                        <img
                                class="dot_45"
                                src="../images/img_32389_0_228.png"
                        />
                    </div>
                    <div class="block_121">
                        <img
                                class="icon_187"
                                src="../images/img_32389_0_229.png"
                        />
                        <img
                                class="dot_46"
                                src="../images/img_32389_0_230.png"
                        />
                    </div>
                    <img
                            class="icon_188"
                            src="../images/img_32389_0_231.png"
                    />
                    <img
                            class="icon_189"
                            src="../images/img_32389_0_232.png"
                    />
                </div>
                <img
                        class="mark"
                        src="../images/img_32389_0_151.png"
                />
                <div class="color_7" />
                <div class="colorDiv_9" />
                <img
                        class="dot_47"
                        src="../images/img_32389_0_181.png"
                />
                <img
                        class="picture_22"
                        src="../images/img_32389_0_182.png"
                />
                <div class="block_123">
                    <img
                            class="icon_190"
                            src="../images/img_32389_0_184.png"
                    />
                    <img
                            class="icon_191"
                            src="../images/img_32389_0_200.png"
                    />
                    <div class="block_122">
                        <img
                                class="pic_18"
                                src="../images/img_32389_0_205.png"
                        />
                        <img
                                class="dot_48"
                                src="../images/img_32389_0_207.png"
                        />
                    </div>
                </div>
                <img
                        class="logo_22"
                        src="../images/img_32389_0_152.png"
                />
                <img
                        class="logo_23"
                        src="../images/img_32389_0_150.png"
                />
                <img
                        class="img_25"
                        src="../images/img_32389_0_153.png"
                />
                <img
                        class="picture_23"
                        src="../images/img_32389_0_183.png"
                />
                <img
                        class="pic_19"
                        src="../images/img_32389_0_187.png"
                />
                <div class="view_46">
                    <img
                            class="image_19"
                            src="../images/img_32389_0_188.png"
                    />
                    <img
                            class="dot_49"
                            src="../images/img_32389_0_191.png"
                    />
                </div>
                <img
                        class="smallItem_2"
                        src="../images/img_32389_0_154.png"
                />
                <img
                        class="logo_24"
                        src="../images/img_32389_0_155.png"
                />
                <img
                        class="logo_25"
                        src="../images/img_32389_0_156.png"
                />
                <img
                        class="icon_192"
                        src="../images/img_32389_0_189.png"
                />
                <img
                        class="dot_50"
                        src="../images/img_32389_0_192.png"
                />
                <img
                        class="smallPic_2"
                        src="../images/img_32389_0_157.png"
                />
                <div class="block_124">
                    <img
                            class="smallItem_3"
                            src="../images/img_32389_0_158.png"
                    />
                    <img
                            class="icon_193"
                            src="../images/img_32389_0_193.png"
                    />
                    <img
                            class="icon_194"
                            src="../images/img_32389_0_194.png"
                    />
                    <img
                            class="picture_24"
                            src="../images/img_32389_0_195.png"
                    />
                    <img
                            class="icon_195"
                            src="../images/img_32389_0_176.png"
                    />
                    <img
                            class="icon_196"
                            src="../images/img_32389_0_177.png"
                    />
                    <img
                            class="image_20"
                            src="../images/img_32389_0_178.png"
                    />
                    <img
                            class="icon_197"
                            src="../images/img_32389_0_179.png"
                    />
                    <img
                            class="dot_51"
                            src="../images/img_32389_0_186.png"
                    />
                    <img
                            class="dot_52"
                            src="../images/img_32389_0_185.png"
                    />
                    <img
                            class="icon_198"
                            src="../images/img_32389_0_180.png"
                    />
                    <img
                            class="icon_199"
                            src="../images/img_32389_0_196.png"
                    />
                    <img
                            class="dot_53"
                            src="../images/img_32389_0_203.png"
                    />
                    <img
                            class="dot_54"
                            src="../images/img_32389_0_202.png"
                    />
                    <img
                            class="icon_200"
                            src="../images/img_32389_0_197.png"
                    />
                </div>
                <img
                        class="icon_201"
                        src="../images/img_32389_0_201.png"
                />
                <img
                        class="pic_20"
                        src="../images/img_32389_0_204.png"
                />
                <img
                        class="icon_202"
                        src="../images/img_32389_0_206.png"
                />
                <img
                        class="dot_55"
                        src="../images/img_32389_0_208.png"
                />
                <img
                        class="dot_56"
                        src="../images/img_32389_0_190.png"
                />
                <img
                        class="icon_203"
                        src="../images/img_32389_0_162.png"
                />
                <img
                        class="icon_204"
                        src="../images/img_32389_0_161.png"
                />
                <img
                        class="icon_205"
                        src="../images/img_32389_0_160.png"
                />
                <img
                        class="icon_206"
                        src="../images/img_32389_0_159.png"
                />
                <img
                        class="pic_21"
                        src="../images/img_32389_0_164.png"
                />
                <img
                        class="img_26"
                        src="../images/img_32389_0_163.png"
                />
                <img
                        class="icon_207"
                        src="../images/img_32389_0_165.png"
                />
                <div class="view_47">
                    <img
                            class="icon_208"
                            src="../images/img_32389_0_166.png"
                    />
                    <img
                            class="icon_209"
                            src="../images/img_32389_0_172.png"
                    />
                    <img
                            class="icon_210"
                            src="../images/img_32389_0_171.png"
                    />
                    <img
                            class="icon_211"
                            src="../images/img_32389_0_170.png"
                    />
                    <img
                            class="icon_212"
                            src="../images/img_32389_0_169.png"
                    />
                    <img
                            class="icon_213"
                            src="../images/img_32389_0_168.png"
                    />
                    <img
                            class="icon_214"
                            src="../images/img_32389_0_167.png"
                    />
                </div>
                <img
                        class="icon_215"
                        src="../images/img_32389_0_175.png"
                />
                <img
                        class="icon_216"
                        src="../images/img_32389_0_174.png"
                />
                <img
                        class="icon_217"
                        src="../images/img_32389_0_173.png"
                />
                <img
                        class="icon_218"
                        src="../images/img_32389_0_211.png"
                />
                <img
                        class="icon_219"
                        src="../images/img_32389_0_213.png"
                />
                <img
                        class="icon_220"
                        src="../images/img_32389_0_214.png"
                />
                <img
                        class="dot_57"
                        src="../images/img_32389_0_216.png"
                />
                <img
                        class="icon_221"
                        src="../images/img_32389_0_215.png"
                />
            </div>
            <div class="view_48">
                <img
                        class="entryPic_26"
                        src="../images/img_32389_0_139.png"
                />
                <div class="block_126">
                    <span class="info_43" :lines="1">深度学习与子人处深</span>
                    <span class="word_26" :lines="1">…</span>
                </div>
                <div class="priceWrap_14">
                    <div class="block_127">
                        <div class="group_26">
                            <img
                                    class="icon_222"
                                    src="../images/img_32389_0_141.png"
                            />
                            <img
                                    class="pic_22"
                                    src="../images/img_32389_0_142.png"
                            />
                            <img
                                    class="icon_223"
                                    src="../images/img_32389_0_143.png"
                            />
                        </div>
                        <span class="num_28" :lines="1">2389</span>
                    </div>
                    <span class="price_15" :lines="1">¥1200.00</span>
                </div>
                <img
                        class="entryPic_27"
                        src="../images/img_32389_0_140.png"
                />
                <div class="block_128">
                    <span class="info_44" :lines="1">深度学习与子人处深</span>
                    <span class="word_27" :lines="1">…</span>
                </div>
                <div class="moneyWrap_14">
                    <div class="block_130">
                        <div class="block_129">
                            <img
                                    class="icon_224"
                                    src="../images/img_32389_0_144.png"
                            />
                            <img
                                    class="picture_25"
                                    src="../images/img_32389_0_145.png"
                            />
                            <img
                                    class="icon_225"
                                    src="../images/img_32389_0_146.png"
                            />
                        </div>
                        <span class="num_29" :lines="1">2389</span>
                    </div>
                    <span class="money_14" :lines="1">¥1200.00</span>
                </div>
            </div>
            <div class="block_136">
                <img
                        class="entryPic_28"
                        src="../images/img_32389_0_131.png"
                />
                <div class="block_131">
                    <span class="info_45" :lines="1">深度学习与子人处深</span>
                    <span class="word_28" :lines="1">…</span>
                </div>
                <div class="priceWrap_15">
                    <div class="block_132">
                        <div class="group_27">
                            <img
                                    class="icon_226"
                                    src="../images/img_32389_0_133.png"
                            />
                            <img
                                    class="image_21"
                                    src="../images/img_32389_0_134.png"
                            />
                            <img
                                    class="icon_227"
                                    src="../images/img_32389_0_135.png"
                            />
                        </div>
                        <span class="num_30" :lines="1">2389</span>
                    </div>
                    <span class="price_16" :lines="1">¥1200.00</span>
                </div>
                <img
                        class="entryPic_29"
                        src="../images/img_32389_0_132.png"
                />
                <div class="block_133">
                    <span class="info_46" :lines="1">深度学习与子人处深</span>
                    <span class="word_29" :lines="1">…</span>
                </div>
                <div class="moneyWrap_15">
                    <div class="block_135">
                        <div class="block_134">
                            <img
                                    class="icon_228"
                                    src="../images/img_32389_0_136.png"
                            />
                            <img
                                    class="img_27"
                                    src="../images/img_32389_0_137.png"
                            />
                            <img
                                    class="icon_229"
                                    src="../images/img_32389_0_138.png"
                            />
                        </div>
                        <span class="num_31" :lines="1">2389</span>
                    </div>
                    <span class="money_15" :lines="1">¥1200.00</span>
                </div>
            </div>
            <div class="view_49">
                <img
                        class="entryPic_30"
                        src="../images/img_32389_0_123.png"
                />
                <div class="block_137">
                    <span class="info_47" :lines="1">深度学习与子人处深</span>
                    <span class="word_30" :lines="1">…</span>
                </div>
                <div class="priceWrap_16">
                    <div class="block_138">
                        <div class="group_28">
                            <img
                                    class="icon_230"
                                    src="../images/img_32389_0_125.png"
                            />
                            <img
                                    class="pic_23"
                                    src="../images/img_32389_0_126.png"
                            />
                            <img
                                    class="icon_231"
                                    src="../images/img_32389_0_127.png"
                            />
                        </div>
                        <span class="num_32" :lines="1">2389</span>
                    </div>
                    <span class="price_17" :lines="1">¥1200.00</span>
                </div>
                <img
                        class="entryPic_31"
                        src="../images/img_32389_0_124.png"
                />
                <div class="block_139">
                    <span class="info_48" :lines="1">深度学习与子人处深</span>
                    <span class="word_31" :lines="1">…</span>
                </div>
                <div class="moneyWrap_16">
                    <div class="block_141">
                        <div class="block_140">
                            <img
                                    class="icon_232"
                                    src="../images/img_32389_0_128.png"
                            />
                            <img
                                    class="picture_26"
                                    src="../images/img_32389_0_129.png"
                            />
                            <img
                                    class="icon_233"
                                    src="../images/img_32389_0_130.png"
                            />
                        </div>
                        <span class="num_33" :lines="1">2389</span>
                    </div>
                    <span class="money_16" :lines="1">¥1200.00</span>
                </div>
            </div>
            <div class="block_147">
                <img
                        class="entryPic_32"
                        src="../images/img_32389_0_115.png"
                />
                <div class="block_142">
                    <span class="info_49" :lines="1">深度学习与子人处深</span>
                    <span class="word_32" :lines="1">…</span>
                </div>
                <div class="priceWrap_17">
                    <div class="block_143">
                        <div class="group_29">
                            <img
                                    class="icon_234"
                                    src="../images/img_32389_0_117.png"
                            />
                            <img
                                    class="image_22"
                                    src="../images/img_32389_0_118.png"
                            />
                            <img
                                    class="icon_235"
                                    src="../images/img_32389_0_119.png"
                            />
                        </div>
                        <span class="num_34" :lines="1">2389</span>
                    </div>
                    <span class="price_18" :lines="1">¥1200.00</span>
                </div>
                <img
                        class="entryPic_33"
                        src="../images/img_32389_0_116.png"
                />
                <div class="block_144">
                    <span class="info_50" :lines="1">深度学习与子人处深</span>
                    <span class="word_33" :lines="1">…</span>
                </div>
                <div class="moneyWrap_17">
                    <div class="block_146">
                        <div class="block_145">
                            <img
                                    class="icon_236"
                                    src="../images/img_32389_0_120.png"
                            />
                            <img
                                    class="img_28"
                                    src="../images/img_32389_0_121.png"
                            />
                            <img
                                    class="icon_237"
                                    src="../images/img_32389_0_122.png"
                            />
                        </div>
                        <span class="num_35" :lines="1">2389</span>
                    </div>
                    <span class="money_17" :lines="1">¥1200.00</span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "floorData"
    }
</script>

<style src="../index.css" scoped />

<style scoped>
    .block_63 .el-card:nth-child(4n){margin-bottom: 15px}
</style>
